export const environment = {
  appVersion: require('../../package.json').version + '-dev',
  production: false,
  staging: false,
  S3_FILE_URL: 'https://mysembrachat.s3.amazonaws.com/',
  // apiURL: 'https://chatapi.sembratest.com/', // 'http://localhost:3002/',
  SEMBRASKILLS_URL: 'https://dev.sembraskills.com/', //STAGE/DEV for now you need press advanced and continue 
  // AUTH_API_URL: 'https://usermgmt.mysembra.com/',//PROD
  AUTH_API_URL: 'https://usermgmt-test.mysembra.com/', //STAGE/DEV
  // AUTH_API_URL: 'http://localhost:3000/', //LOCAL
  // SEMBRATIME_URL: 'https://time.devsembra.com',
  SEMBRATIME_URL: 'https://time.mysembra.com',
  TEMPLATE_URL: 'https://template.mysembra.com',
  ONBOARDING_URL: 'https://onboarding.mysembra.com',
  FEEDBACK_URL: 'https://feedback.mysembra.com',
  EVVADMIN_URL: 'https://evvadmin.mysembra.com',
  DOCUMENTMANAGER_URL: 'https://documentmanager.mysembra.com',
  SEMBRANET_URL: 'https://net.sembratest.com/auth/login',
  appDisplayName: "MySembra",
  appName:"MySembra",
  realm:"Sembracare",
  // SEMBRANET_URL: 'https://snetpwa.sembratest.com', //UPDATE TO MYSEMBRA
  // firebase: {
  //   apiKey: 'AIzaSyCtyNmJobwYHXGKX8bodAOweNonWUz8xKc',
  //   authDomain: 'angularpush-6933c.firebaseapp.com',
  //   projectId: 'angularpush-6933c',
  //   storageBucket: 'angularpush-6933c.appspot.com',
  //   messagingSenderId: '697096402019',
  //   appId: '1:697096402019:web:6af286e8e52486cd97b456',
  //   measurementId: 'G-8JWR567H9P',
  //   vapidKey: 'BP1gzMZLV-Lb2lF9Ke52aM4YMIA7VoXz0MmmK7RbJ_ukj4wv3XJmuyOhM2yOPOcS0ex6-emfb25gBJwfx07Cykw'
  // },
  firebase: {
    apiKey: "AIzaSyBBMorNkMlnr3ToAmzx6APFfmxlrJB2Y1M",
    authDomain: "mysembrachat.firebaseapp.com",
    projectId: "mysembrachat",
    storageBucket: "mysembrachat.appspot.com",
    messagingSenderId: "1063883798668",
    appId: "1:1063883798668:web:99ca28189e7ba6fad163a9",
    measurementId: "G-8KL254HPHE",
    vapidKey: 'BIUfpOa59aZMiVBGF1dZehNZfgeSur2Fisd6RNfKPB_ujl84GUCIEvTjnRr3i9dc6WBa4YLH9OdjMff3BhGCo0M'
  }
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/dist/zone-error';  // Included with Angular CLI.
